export enum COLLECTION_TYPE {
  CURATED = 'curated',
  BROWSE = 'browse',
}
